import { getParam, useQuery } from '~utils/query';

export const useIsView = type => {
  const view = getParam(useQuery(), 'view');
  return view === type;
};
